import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/shared/services/users.service';

@Component({
  selector: 'app-welding',
  templateUrl: './welding.component.html',
  styleUrls: ['./welding.component.css']
})
export class WeldingComponent implements OnInit {
  data = {
    module : "Welding"
  }

  constructor(
    private usersService : UsersService,
    private router: Router
  ) { 
    
  }

  ngOnInit(): void {
  }

  async completed() {
    
    let courseCompleted = {
      module5: this.data.module
    }
    await this.usersService.userProgress(courseCompleted);
   
    this.router.navigate(['/dashboard']);
  }

}
